export default {"src":"/_next/static/media/google-logo.f9ab09c8.svg","height":37,"width":113,"blurWidth":0,"blurHeight":0};